import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { customerApi } from "@/lib/customerApi";
import { formatApiError } from "@/lib/api";
import { readFragmentToken } from "@/lib/consumerCommerce";
import SEO from "@/components/SEO";

export default function AccountVerifyEmailChange() {
  const location = useLocation();
  const { refresh } = useCustomerAuth();
  const token = useRef(null);
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  useEffect(()=>{
    if (token.current !== null) return;
    token.current=readFragmentToken(location.hash);
    window.history.replaceState(null,"",location.pathname);
    setReady(true);
  },[location.hash,location.pathname]);
  const confirm=async()=>{
    setBusy(true);setError("");
    try {
      await customerApi.post("/customers/email-change/complete",{token:token.current});
      await refresh();setDone(true);
    } catch(err){setError(formatApiError(err));}
    finally{setBusy(false);}
  };
  return <div className="lf-section min-h-[60vh] bg-ink-50/40"><SEO title="Confirm your email — LightningFlow" noIndex /><div className="lf-container">
    <section className="mx-auto max-w-md border border-ink-100 bg-white p-7 md:p-9">
      <div className="lf-eyebrow">LightningFlow account</div>
      <h1 className="mt-3 font-display text-2xl font-black">{done ? "Your email has been updated." : "Confirm your email change"}</h1>
      <p className="mt-4 text-sm text-ink-600">{done ? "Your purchases and products remain with the same account. Sign in with your new email." : ready && !token.current ? "This link is invalid. Request a new verification link in your profile." : "Confirm only if you requested this change. This updates your account's sign-in email and signs out browser sessions."}</p>
      {!done && ready && token.current ? <button className="lf-btn-primary mt-6" type="button" disabled={busy} onClick={confirm}>{busy ? "Confirming…" : "Confirm email change"}</button> : null}
      {error ? <p className="mt-4 text-sm text-red-600" role="alert">{error}</p> : null}
      <Link className="lf-link mt-6 block" to="/account">{done ? "Sign in" : "Back to your account"}</Link>
    </section>
  </div></div>;
}
